module.exports = __webpack_public_path__ + "static/media/upload.0e2b6278.svg";